import React from 'react';
import { FormLabel } from '@biq/apex-ui';
import { SxProps } from '@mui/material';
import { InfoTooltipIcon } from '../../../../components';

interface JobFieldHeadingWithTooltipProps {
    label: string;
    required?: boolean;
    title: string;
    popperStyles?: SxProps;
    modifiers?: [
        {
            name: string;
            options: {
                offset: [number, number];
            };
        },
    ];
}

const styles = {
    labelStyles: {
        mr: '2px',
    },
};

export const JobFieldHeadingWithTooltip = ({
    label,
    required,
    title,
    popperStyles,
    modifiers,
}: JobFieldHeadingWithTooltipProps): React.JSX.Element => {
    return (
        <>
            <FormLabel
                label={label}
                required={required}
                sx={styles.labelStyles}
            />
            <InfoTooltipIcon
                title={title}
                popperStyles={popperStyles}
                modifiers={modifiers}
            />
        </>
    );
};
